export const COLORS = {
    SWITCH_TOGGLE_DEFAULT_COLOR_CHECKED: '#2CCC71',
    SWITCH_TOGGLE_DEFAULT_COLOR_UNCHECKED: '#ADB1BB',
    HOME_OWNERSHIP_PRICE_RANGE: '#E4E4E4',
    HOME_OWNERSHIP_PRICE_RANGE_CURRENT_VALUE: '#1ACEB3',
    PRIMARY_COLOR: '#1ACEB3',
    ACCENT_COLOR: '#8B909E',
};
